import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=23acdfc4&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=23acdfc4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23acdfc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23acdfc4')) {
      api.createRecord('23acdfc4', component.options)
    } else {
      api.reload('23acdfc4', component.options)
    }
    module.hot.accept("./pay.vue?vue&type=template&id=23acdfc4&scoped=true", function () {
      api.rerender('23acdfc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/pay/pay.vue"
export default component.exports